import { render, staticRenderFns } from "./ListRetiradosPage.vue?vue&type=template&id=3b3b9c7c&scoped=true"
import script from "./ListRetiradosPage.vue?vue&type=script&lang=js"
export * from "./ListRetiradosPage.vue?vue&type=script&lang=js"
import style0 from "./ListRetiradosPage.vue?vue&type=style&index=0&id=3b3b9c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b9c7c",
  null
  
)

export default component.exports